import React, { memo } from 'react';
import { makeStyles } from '@mui/styles';
import { Tooltip } from '@mui/material';

import { WarningIcon } from '../icons';

const useStyles = makeStyles(() => ({
  warningIcon: {
    width: '1rem',
    height: '1rem',
  },
}));

const WarningWithTooltip = ({ routes }) => {
  const classes = useStyles();
  const message = `An outstanding request on route(s): ${routes.join(', ')}`;
  return (
    <Tooltip
      title={message}
      interactive
      PopperProps={{
        placement: 'top-end',
        popperOptions: {
          modifiers: {
            offset: {
              enabled: true,
              offset: '0, -10',
            },
            flip: {
              enabled: false,
            },
            hide: {
              enable: true,
            },
          },
        },
      }}
    >
      <span>
        <WarningIcon className={classes.warningIcon} />
      </span>
    </Tooltip>
  );
};

export default memo(WarningWithTooltip);
